import React from 'react';

import { ActionButtons, DeliveriesAndAppointments } from './components';

export const SnapshotCardContent: React.FC = () => (
  <>
    <DeliveriesAndAppointments />
    <ActionButtons />
  </>
);
